module.exports = __webpack_public_path__ + "img/racecourse-greyville-turf-1900.061136de.svg";